export default class ScrollToAnchor {
   constructor() {
      this.navbar = document.querySelector('.navbar')
      this.init()
   }

   init() {
      const links = document.querySelectorAll('a[href^="#"]:not([href="#"])')
      for (const link of links) {
         link.addEventListener('click', this.clickHandler)
      }

      this.scrollByUriHash()
   }

   clickHandler(e) {
      e.preventDefault()
      const href = this.getAttribute('href')
      const sections = document.querySelectorAll(href)
      const siteUrl = php_vars.siteUrl

      if (sections.length > 0) {
         const navbarHeight = window.innerWidth > 1023 ? 80 : 60
         const offsetTop = document.querySelector(href).offsetTop - navbarHeight
         scroll({
            top: offsetTop,
            behavior: 'smooth',
         })
      }
  
      if (sections.length == 0 && e.target.closest('.navbar__menu')) {
         window.location.href = siteUrl + href
      }
   }

   scrollByUriHash() {
      if (window.location.hash) {
         const hash = window.location.hash
         if (document.querySelector(hash)) {
            const navbarHeight = window.innerWidth > 1023 ? 80 : 60
            const offsetTop = document.querySelector(hash).offsetTop - navbarHeight
            setTimeout(() => {
               scroll({
                  top: offsetTop,
                  behavior: 'smooth',
               })
            }, 0)
         }
      }
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/scroll-to-anchor.js
// module id = 12
// module chunks = 0